import { motion } from 'framer-motion';
import type { ReactNode } from 'react';
import React from 'react';
import GridAndLight from '../../assets/images/grid-and-light.png';
import LigthImage from '../../assets/images/light-image.png';
import styles from './Container.module.scss';

export interface ContainerProps {
	backgroundImage?: string;
	children?: ReactNode;
	isGrid?: boolean;
	isLight?: boolean;
	isOverlay?: boolean;
}

const Container = ({ children, isGrid, isLight, isOverlay, backgroundImage }: ContainerProps) => {
	return (
		<>
			{isOverlay ? <div className={styles.overlay} /> : null}
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 0.3 }}
				className={styles.container}
			>
				{backgroundImage ? <img src={backgroundImage} className={styles.backgroundImage} alt='background' /> : null}
				<div className={styles.ligthWrapper}>
					{isLight && !isGrid ? <img src={LigthImage} className={styles.lightImg} alt='background' /> : null}
					{isGrid ? <img src={GridAndLight} className={styles.lightImg} alt='background' /> : null}
				</div>
				<div className={styles.content}>{children}</div>
			</motion.div>
		</>
	);
};

export default Container;
